import { useEffect, useState } from 'react'

/**
 * Custom hook to track the visibility state of the page.
 * Example: when the user switches to another tab, isVisible would be false.
 * Returns an object with a boolean `isVisible` property.
 *
 * @returns {Object} - An object containing the visibility state.
 */

export const usePageVisibility = () => {
  const [isVisible, setIsVisible] = useState(() => {
    if (typeof document === 'undefined') {
      return true
    }

    return document.visibilityState === 'visible'
  })

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === 'visible')
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return { isVisible }
}
